var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessDbt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3CFFF;}\r\n\t.st1{fill:#4C66D6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,90c21.5,0,39-17.5,39-39S71.5,12,50,12S11,29.5,11,51S28.5,90,50,90z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,14c20.4,0,37,16.6,37,37S70.4,88,50,88S13,71.4,13,51S29.6,14,50,14z M50,10C27.4,10,9,28.4,9,51 s18.4,41,41,41s41-18.4,41-41S72.6,10,50,10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,61.8c-0.1-0.1-0.1-0.2-0.1-0.3V40.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h7.9 c1.6,0,3,0.3,4.2,0.8c1.2,0.6,2.1,1.3,2.8,2.3c0.6,1,1,2.2,1,3.5v8.7c0,1.3-0.3,2.5-1,3.5c-0.7,1-1.6,1.8-2.8,2.4 c-1.2,0.6-2.6,0.8-4.2,0.8h-7.9C23.7,61.9,23.6,61.8,23.5,61.8z M28,58h3.8c1,0,1.7-0.3,2.4-1c0.6-0.7,0.9-1.5,0.9-2.6v-7.3 c0-1.1-0.3-2-0.9-2.6c-0.6-0.6-1.4-1-2.4-1H28c-0.1,0-0.2,0-0.2,0.2v14.2C27.9,58,27.9,58,28,58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,50.5c2,1,3,2.8,3,5.1c0,2-0.7,3.6-2.1,4.6c-1.4,1-3.2,1.6-5.5,1.6h-8.2c-0.1,0-0.2,0-0.3-0.1 S43,61.6,43,61.5V40.1c0-0.1,0-0.2,0.1-0.3s0.2-0.1,0.3-0.1h7.9c5,0,7.5,2,7.5,6.1c0,2.1-0.9,3.6-2.7,4.5C56,50.4,56,50.5,56.1,50.5 z M47.4,43.7v4.9c0,0.1,0.1,0.2,0.2,0.2h3.7c1,0,1.8-0.2,2.3-0.7c0.5-0.5,0.8-1.1,0.8-1.9c0-0.8-0.3-1.5-0.8-1.9s-1.3-0.7-2.3-0.7 h-3.7C47.5,43.6,47.4,43.6,47.4,43.7z M53.8,57.3c0.5-0.5,0.8-1.2,0.8-2c0-0.9-0.3-1.5-0.8-2c-0.6-0.5-1.3-0.7-2.3-0.7h-3.9 c-0.1,0-0.2,0.1-0.2,0.2v5.3c0,0.1,0.1,0.2,0.2,0.2h3.9C52.5,58,53.3,57.8,53.8,57.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.5,39.8c0.1,0.1,0.1,0.2,0.1,0.3v3.1c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-5.7 c-0.1,0-0.2,0.1-0.2,0.2v17.7c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1h-3.7c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.3V43.8 c0-0.1,0-0.2-0.2-0.2h-5.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-3.1c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h15.9 C77.3,39.7,77.4,39.8,77.5,39.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessDbt);
export default __webpack_public_path__ + "static/media/AssessDbt.ce7ae0d151ff50a10b718fcd6b9174bf.svg";
export { ForwardRef as ReactComponent };